module.exports = __webpack_public_path__ + "img/4-2.8fff6ef0.png";